import React from 'react';
import { ReactComponent as CloseIcon } from 'src/assets/icons/close.svg';
import { getFileIcon } from 'src/utils/fileIcons';
import { UploadedFile } from 'src/hooks/useFileUploadWithValidation';
import { IAttachmentUpload } from 'src/types/attachments';
import {
    UploadProgressContainer,
    UploadProgressItem,
    UploadProgressFileInfo,
    UploadProgressFileName,
    UploadProgressBarContainer,
    UploadProgressBar,
    UploadProgressFill,
    UploadProgressPercent,
    UploadProgressCancelButton
} from './styled';

interface UploadProgressProps {
    files: (UploadedFile | IAttachmentUpload)[];
    onCancelUpload: (fileId: number) => void;
}

const UploadProgress: React.FC<UploadProgressProps> = ({
    files,
    onCancelUpload
}) => {
    const uploadingFiles = files.filter((file) => file.status === 'uploading');

    if (uploadingFiles.length === 0) {
        return null;
    }

    return (
        <UploadProgressContainer>
            {uploadingFiles.map((file) => (
                <UploadProgressItem key={`progress-${file.id}`}>
                    <UploadProgressFileInfo>
                        {getFileIcon(file.file.type)}
                        <UploadProgressFileName>
                            {file.file.name}
                        </UploadProgressFileName>
                    </UploadProgressFileInfo>

                    <UploadProgressBarContainer>
                        <UploadProgressBar>
                            <UploadProgressFill
                                progress={file.uploadProgress || 0}
                            />
                        </UploadProgressBar>
                    </UploadProgressBarContainer>

                    <UploadProgressPercent>
                        {file.uploadProgress}%
                    </UploadProgressPercent>

                    <UploadProgressCancelButton
                        onClick={() => onCancelUpload(file.id)}
                    >
                        <CloseIcon width={12} height={12} />
                    </UploadProgressCancelButton>
                </UploadProgressItem>
            ))}
        </UploadProgressContainer>
    );
};

export default UploadProgress;
